var _a, _b, _c;
export var ShadowSize;
(function (ShadowSize) {
    ShadowSize["S"] = "S";
    ShadowSize["M"] = "M";
    ShadowSize["L"] = "L";
    ShadowSize["XL"] = "XL";
})(ShadowSize || (ShadowSize = {}));
export var ShadowColor;
(function (ShadowColor) {
    ShadowColor["azure"] = "Azure";
    ShadowColor["mineshaft"] = "Mineshaft";
    ShadowColor["shytomato"] = "Shytomato";
})(ShadowColor || (ShadowColor = {}));
var yProperty = (_a = {},
    _a[ShadowSize.S] = '2px',
    _a[ShadowSize.M] = '4px',
    _a[ShadowSize.L] = '6px',
    _a[ShadowSize.XL] = '10px',
    _a);
var blurProperty = (_b = {},
    _b[ShadowSize.S] = '8px',
    _b[ShadowSize.M] = '16px',
    _b[ShadowSize.L] = '24px',
    _b[ShadowSize.XL] = '32px',
    _b);
var spreadProperty = (_c = {},
    _c[ShadowSize.S] = '0',
    _c[ShadowSize.M] = '-2px',
    _c[ShadowSize.L] = '-2px',
    _c[ShadowSize.XL] = '-4px',
    _c);
var colorProperty = function (size) {
    var _a, _b, _c;
    var _d, _e;
    return (_a = {},
        _a[ShadowColor.azure] = "rgba(48, 50, 193, " + (size === ShadowSize.XL ? '0.25' : '0.2') + ")",
        _a[ShadowColor.mineshaft] = "rgba(33, 33, 33, " + ((_d = (_b = {},
            _b[ShadowSize.S] = '0.15',
            _b[ShadowSize.XL] = '0.35',
            _b)[size]) !== null && _d !== void 0 ? _d : '0.2') + ")",
        _a[ShadowColor.shytomato] = "rgba(201, 20, 50, " + ((_e = (_c = {},
            _c[ShadowSize.S] = '0.15',
            _c[ShadowSize.XL] = '0.35',
            _c)[size]) !== null && _e !== void 0 ? _e : '0.2') + ")",
        _a);
};
export var getShadows = function (shadowSize, shadowColor) {
    return "0 " + yProperty[shadowSize] + " " + blurProperty[shadowSize] + " " + spreadProperty[shadowSize] + " " + colorProperty(shadowSize)[shadowColor];
};
